export default __webpack_public_path__ + "static/media/beneficiosImg.34788c5b.png";